// extracted by mini-css-extract-plugin
export default {"option":"Option_option__Ncljc","btn":"Option_btn__pG-DX","imageDescription":"Option_imageDescription__ow-bM","image":"Option_image__3ihKT","description":"Option_description__I+AcE"};